import { generatePath, useNavigate } from 'react-router-dom';
import { settingsModulePaths } from 'core/routes/routes';
import { NEW_NOTIFICATION_SEGMENT } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.constants';

const buildFormPath = (customAlarmDefinitionId: string) =>
    generatePath(settingsModulePaths.operatorCustomNotificationForm, { customAlarmDefinitionId });

export const useOperatorCustomNotificationsNavigation = () => {
    const navigate = useNavigate();

    return {
        navigateToCreate: () => navigate(buildFormPath(NEW_NOTIFICATION_SEGMENT)),
        navigateToEdit: (id: string) => navigate(buildFormPath(id)),
        navigateToList: () => navigate(settingsModulePaths.operatorCustomNotifications),
    };
};
